export type V2Language = "fr" | "en";

export const v2Translations = {
  fr: {
    nav: {
      home: "Accueil",
      work: "Nos réalisations",
      stories: "Témoignages",
      about: "À propos",
      cta: "Appel diagnostic",
    },
    hero: {
      eyebrow: "Agence développement SaaS & Logiciel",
      headline1: "Le partenaire technique qui comprend votre business, pas seulement votre code.",
      subcopy: "Le cofondateur technique que vous n'avez jamais eu. Nous reconstruisons et scalons les plateformes SaaS des fondateurs que leur première version commence à freiner, ou qui n'ont jamais démarré sur de bonnes bases. Léman IT s'approprie vos enjeux et votre vision avant d'écrire la moindre ligne de code.",
      microcopy: "30 minutes d'audit de votre architecture, offertes. Pas de discours commercial, juste un diagnostic honnête.",
      ctaPrimary: "Alignez votre business et votre code",
      ctaSecondary: "Diagnostic, pas de pitch",
      stat1Title: "Nos succès",
      stat1Label: "plateformes SaaS scalées",
      stat1Prefix: "",
      stat1Suffix: "+",
      stat2Label: "garanti dès le J-1",
      stat2Value: "100% propriétaire du Serveur et Code",
      stat2Sub: "Pas d'exceptions · Pas d'astérisques",
      stat3Label: "Migrations sans interruption de service",
      stat3Value: "00:00",
      tickerItems: [
        "Migration sans interruption",
        "100 % de propriété du code",
        "COÛTS FIXES · PAS DE FACTURES SURPRISE",
        "RGPD · HDS Conforme",
        "Architecture IA-ready",
        "Partenaire technique à vie",
      ],
    },
    filter: {
      headline: "Cette offre est pensée pour un profil de fondateur très précis. Est-ce le vôtre ?",
      yesLabel: "Oui, vous êtes au bon endroit",
      yesLetter: "A.",
      yesTitle: "Vous êtes au bon endroit si :",
      yesItems: [
        "La première version de votre SaaS fonctionne, mais vous avez peur de la faire grandir parce que les fondations ne suivront pas.",
        "Un développeur vous a livré le code puis a disparu. Vous en gérez seul les conséquences.",
        "Vous n'osez plus promouvoir votre produit, de peur de ce que vos utilisateurs pourraient y trouver.",
        "Vous avez hérité d'une plateforme que vous n'avez pas construite, et vous traînez la dette technique d'un autre.",
        "Votre plateforme traite des données sensibles et vous n'êtes pas certain de sa conformité RGPD ou HDS.",
      ],
      noLabel: "Non, ce n'est pas pour vous",
      noLetter: "B.",
      noTitle: "Cette offre n'est pas faite pour vous si :",
      noItems: [
        "Vous cherchez l'option la plus rapide ou la moins chère du marché. Un travail de qualité demande du temps et des itérations nécessaires.",
        "Vous voulez remettre un cahier des charges et ne plus toucher aux décisions produit.",
        "Il vous faut une grosse agence capable de mener des dizaines de chantiers en parallèle.",
      ],
    },
    antiAgency: {
      headline: "Arrêtez de gérer votre agence de dev. Commencez enfin à grandir avec un vrai partenaire.",
      subheadline: "Nous vous apportons des solutions avant même que vous sachiez en avoir besoin.",
      labelProblem: "Le problème",
      labelApproach: "Notre approche",
      body1: "La plupart des studios de dev tournent sur la même recette éculée. Vous envoyez un brief, on vous renvoie un fichier zip, et plus personne ne donne de nouvelles.",
      body2Intro: "Entre les deux, un architecte senior signe la vente, puis confie discrètement le cœur de votre produit au junior le moins cher sous la main.",
      body2List: [
        "Vous courez après des développeurs qui répondent une semaine sur deux.",
        "Vous payez des modifications dues à des choix faits sans rien comprendre à votre activité.",
        "Vous pilotez un projet censé, justement, vous libérer du pilotage.",
      ],
      body3: "Léman IT ne se contente pas d'exécuter un brief. <strong>Nous le remettons en question.</strong>",
      body4Parts: [
        "Avant d'écrire une ligne de code, nous assimilons votre modèle de monétisation, vos contraintes commerciales et la logique de votre produit.",
        "Vous n'avez pas à traduire vos décisions business en langage technique : <strong>c'est notre métier.</strong>",
        "Et une fois la plateforme en ligne, nous ne disparaissons pas.",
        "<strong>Nous restons votre partenaire technique sur la durée</strong>, à chaque version, chaque pivot, chaque changement d'échelle.",
      ],
      testimonial1: {
        quoteTitle: "Un partenaire fiable, capable de créer de la valeur durable.",
        body: "Il se distingue par une excellente capacité d'exécution, alliée à une compréhension fine de l'environnement opérationnel dans lequel s'inscrivent les solutions développées. Au-delà de la qualité technique de son travail, Thibault sait rapidement appréhender les enjeux métiers et proposer des solutions adaptées, robustes et efficaces.",
        author: "Maren Knief Clerc",
        role: "Strategic Advisor, COO chez KC Advisory",
      },
    },
    sixtyForty: {
      headline: "La différence se joue dans ce que nous proposons avant même que vous le demandiez.",
      subtitle: "Léman IT apporte une vision stratégique, signale les risques en amont et livre des solutions qui durent. Pas seulement du code livré en production.",
      visibleLabel: "Périmètre visible",
      visiblePct: "60",
      visibleDesc: "% du brief classique",
      hiddenLabel: "Périmètre invisible",
      hiddenPct: "40",
      hiddenDesc: "% invisible",
      body1: "Un cahier des charges technique classique couvre environ 60 % de ce dont votre logiciel a réellement besoin pour tenir sur son marché.",
      body2: "Les 40 % restants sont invisibles, jusqu'au moment où ils ne le sont plus. Des cas limites qui cèdent sous la charge réelle des utilisateurs, des goulots d'étranglement opérationnels que votre équipe contourne à coups de tableurs, une infrastructure de montée en charge que personne n'a pensé à spécifier. La plupart des agences construisent les 60 %, livrent, et vous facturent le reste à part.",
      body3: "Nous cartographions les 100% et couvrons les besoins non-anticipés dans le cahier des charges.",
      body4: "Les angles morts sont identifiés, cadrés et intégrés au cœur du système. Pas découverts après le lancement, quand les corriger coûte trois fois plus cher.",
      caseStudy: {
        title: "Une cliente nous a demandé une simple page pour afficher ses communiqués de presse.",
        highlight: "Nous lui avons livré un véritable système de gestion des communiqués de presse.",
        body1: "Elle peut désormais publier, modifier et archiver ses communiqués en toute autonomie. Sans appeler un développeur. Sans facture à la clé. Sans la moindre friction technique.",
        body2: "Elle ne l'avait pas demandé. Nous le lui avons proposé, et c'est devenu un vrai levier pour son activité.",
        ctaBody: "Voilà les 40 %.",
        cta: "Voir tous les systèmes livrés",
      },
    },
    scopePillars: {
      headline: "Adapté. Robuste. Efficace. Les trois mots qui reviennent chez nos clients.",
      pillars: [
        {
          tag: "Architecture",
          title: "Une plateforme stable, conçue pour grandir",
          body: "Reconstruite de zéro sur une architecture propre. Dette technique éliminée, dépendance fournisseur supprimée. <strong>100% propriétaire de votre code dès le J-1.</strong> Sans exception, sans astérisque.",
        },
        {
          tag: "Discovery",
          title: "Cartographier vos besoins produit invisibles",
          body: "La règle des 60/40 s'applique directement à votre projet. <strong>Nous remettons activement en question la logique de vos fonctionnalités et comblons les failles d'architecture</strong> avant qu'elles ne tournent à l'urgence coûteuse après le lancement.",
        },
        {
          tag: "Autonomie",
          title: "Le tableau de bord anti-dépendance",
          body: "Un back-office sur mesure, construit autour de vos vrais flux de travail. <strong>Pilotez et mettez à jour votre plateforme au quotidien, sans développeur d'astreinte</strong>, sans traducteur technique, sans friction.",
        },
        {
          tag: "Migration",
          title: "Migration progressive, sans interruption",
          body: "Vos revenus actuels restent protégés pendant toute la transition. <strong>La nouvelle plateforme se déploie dans un environnement entièrement parallèle et migre vos utilisateurs en douceur.</strong> Zéro perturbation opérationnelle.",
        },
        {
          tag: "Infra",
          title: "Infrastructure et déploiement en production",
          body: "Architecture cloud de niveau entreprise, avec supervision des performances en temps réel et montée en charge automatique. <strong>Une année complète d'hébergement sécurisé est incluse dans la prestation.</strong> Aucun coût d'infrastructure caché.",
        },
        {
          tag: "Automation",
          title: "Intégrations API et automatisation intelligentes",
          body: "Contournements manuels, outils déconnectés et ressaisies répétitives, éliminés définitivement. Nous les remplaçons par <strong>des pipelines automatisés, conçus pour tourner sans surveillance.</strong>",
        },
        {
          tag: "Croissance",
          title: "Infrastructure analytique et de croissance",
          body: "Suivi des conversions, analyse du comportement utilisateur et mesure des performances sont intégrés à votre code dès le premier jour. <strong>Vous grandissez sur des données, pas sur des intuitions.</strong>",
        },
        {
          tag: "IA Ready",
          title: "Un socle prêt pour l'IA",
          body: "Votre architecture est pensée dès le départ avec des bases de données vectorielles sécurisées et une infrastructure prête pour l'IA. <strong>Quand vous déploierez des fonctionnalités IA, vos coûts opérationnels et d'API resteront prévisibles, pas incontrôlables.</strong>",
        },
      ],
      testimonial2: {
        quoteTitle: "Leur maîtrise technique fait vraiment la différence.",
        body: "C'est une équipe de développeurs fullstack très compétente, rigoureuse et toujours force de proposition. Leur maîtrise technique, combinée à leur capacité à comprendre rapidement les besoins métier, fait vraiment la différence. En plus de leurs compétences techniques, LémanIT est fiable, professionnel et agréable à travailler au quotidien.",
        author: "Ambre Roguet",
        role: "Head of Operations chez Around SA",
      },
    },
    faq: {
      headline: "Questions fréquentes",
      highlight: "honnêtement répondues.",
      subtitle: "Six questions que tout fondateur se pose avant de nous confier son produit. Sans langue de bois.",
      items: [
        {
          q: "Devons-nous mettre en pause notre marketing ou nos ventes pendant la reconstruction ?",
          a: "Non. Votre plateforme actuelle reste 100 % active, en ligne et génératrice de revenus. Votre business continue d'intégrer ses utilisateurs normalement pendant que nous développons et testons la nouvelle version en parallèle, sur un serveur séparé et sécurisé. Nous ne basculons que lorsque le nouveau système est irréprochable.",
        },
        {
          q: "Que se passe-t-il une fois le produit en ligne ?",
          a: "La plupart des agences vous remettent un dossier de code illisible puis disparaissent, ou vous enferment dans des forfaits horaires coûteux. Léman IT reste votre partenaire technique pour toute la vie de votre produit. Vous avez un accès téléphonique direct à l'architecte principal, pas un chef de projet, pas un ticket de support, pas un filtre junior. Une ligne directe pour des décisions stratégiques rapides, du lancement jusqu'au bout.",
        },
        {
          q: "Pourquoi commencer par un appel diagnostic plutôt que par un devis ferme ?",
          a: "Chaque version de SaaS porte sa propre histoire : dette technique, bases de données non optimisées, risques de migration. Envoyer un devis générique sans analyser votre code existant serait profondément irresponsable, et mènerait forcément à de mauvaises surprises sur la facture. L'appel diagnostic protège votre budget.",
        },
        {
          q: "Quelles technologies utilisez-vous pour la reconstruction du SaaS V2 ?",
          a: "Nous travaillons sur des stacks modernes, standards du secteur et faciles à maintenir : principalement Next.js, React, Node.js, PostgreSQL et Supabase. Nous évitons soigneusement les systèmes obscurs, dépassés ou propriétaires, pour que n'importe quel ingénieur de bon niveau puisse reprendre et faire évoluer votre code demain.",
        },
        {
          q: "Comment suit-on l'avancement et comment communique-t-on pendant le développement ?",
          a: "Nous travaillons en sprints courts et totalement transparents, avec une démo en direct chaque semaine. Nous utilisons ClickUp pour le suivi détaillé des tâches et vous donnons un accès permanent, en temps réel, à un environnement de préproduction dédié. Vous voyez votre plateforme évoluer jour après jour.",
        },
        {
          q: "Comment mesurez-vous concrètement que la nouvelle plateforme est meilleure ?",
          a: "Nous ne nous fions pas à l'intuition. Nous suivons des données concrètes en intégrant directement dans le code le suivi des conversions, les Core Web Vitals et les outils d'analyse comportementale. Le succès se mesure après le lancement, par des tests de vitesse précis, une baisse nette des coûts serveur et des métriques d'optimisation.",
        },
      ],
      testimonial3: {
        quoteTitle: "Leur sérieux, leur assiduité, leur niveau de technicité.",
        body: "Je recommande fortement LémanIT, avec qui j'ai eu l'opportunité de travailler sur plusieurs projets. Tout d'abord pour leur sérieux, leur assiduité ainsi que leur niveau de technicité.",
        author: "Mehdi Maamor",
        role: "Business Developer chez Dealzit",
      },
    },
    finalCta: {
      headline: "La première conversation est un diagnostic, pas un appel commercial.",
      subheadline: "Nous regardons votre produit existant, comprenons votre situation, et vous disons honnêtement ce qu'exige une reconstruction, avant même de parler de périmètre ou de prix.",
      cta: "Alignez votre business et votre code",
      microcopy: "30 minutes d'audit de votre architecture, offertes. Pas de discours commercial, juste un diagnostic honnête.",
      directLine: "Ligne Direct - Pas d'intermédiaire",
      directTitle: "Parlez directement avec l'architecte principal.",
      emailLabel: "Email",
      email: "dev@leman-it.com",
      phoneLabel: "Téléphone",
      phone: "+33635389512",
      responseLabel: "Délai de réponse",
      response: "Sous 12h, du lundi au vendredi",
    },
    booking: {
      buttonLabel: "Réserver",
      ariaLabelOpen: "Réserver un appel de 30 minutes",
      ariaLabelClose: "Fermer le calendrier",
    },
    footer: {
      tagline: "Le cofondateur technique que vous n'avez jamais eu. Basé sur les rives du Léman. Nous construisons des plateformes SaaS qui survivent à l'échelle.",
      yearLabel: "MMXXV · Genève",
      copyright: "© Léman IT SARL · Tous droits réservés.",
      practice: "Practice",
      stack: "Stack",
      company: "Company",
    },
  },
  en: {
    nav: {
      home: "Home",
      work: "Our Work",
      stories: "Client Stories",
      about: "About",
      cta: "Book Diagnostic Call",
    },
    hero: {
      eyebrow: "SaaS & Software Development Agency",
      headline1: "The Technical Partner That Understands Your Business, Not Just Your Code.",
      subcopy: "The technical co-founder you never had. We rebuild and scale SaaS platforms for founders who've outgrown their first version.",
      microcopy: "* Claim your free 30-minute architecture review. No sales pitch, just honest diagnostics.",
      ctaPrimary: "Align my business and code",
      ctaSecondary: "Diagnostic, not pitch.",
      stat1Title: "Track record",
      stat1Label: "SaaS platforms scaled to V2",
      stat1Prefix: "",
      stat1Suffix: "+",
      stat2Label: "100% Owned",
      stat2Value: "Server & Code Ownership.",
      stat2Sub: "No exceptions · No asterisks",
      stat3Label: "Downtime on migration. Phased & parallel.",
      stat3Value: "00:00",
      tickerItems: [
        "Zero-Downtime Migration",
        "100% Code Ownership",
        "FIXED COSTS · NO SURPRISE INVOICES",
        "GDPR · HDS Compliance",
        "AI-Ready Architecture",
        "Lifetime Technical Partner",
      ],
    },
    filter: {
      headline: "This is engineered for one specific founder. Is it you?",
      yesLabel: "Yes, right place",
      yesLetter: "A.",
      yesTitle: "You are in the right place if…",
      yesItems: [
        "Your first version of SaaS works, but you are afraid to scale it because the foundation will not hold.",
        "A developer delivered the code and went silent. You are managing the consequences alone.",
        "You stopped promoting your own product because you did not trust what users would find.",
        "You inherited a platform you did not build and are carrying someone else's technical debt.",
        "Your platform handles sensitive data, and you are not certain it is compliant with GDPR or HDS.",
      ],
      noLabel: "No, not a fit",
      noLetter: "B.",
      noTitle: "This offer is not the right fit if…",
      noItems: [
        "You are looking for the fastest or cheapest option available on the market.",
        "You want to hand over a specification sheet and not be involved in any product decisions.",
        "You need a massive agency team running dozens of parallel workstreams simultaneously.",
      ],
    },
    antiAgency: {
      headline: "Stop managing your dev agency. Start growing with a partner.",
      subheadline: "We bring you solutions before you know you need them.",
      labelProblem: "The problem",
      labelApproach: "Our approach",
      body1: "Most development shops run on the same broken playbook. You hand over a brief, they hand back a zip file, and you never hear from them again.",
      body2Intro: "In between, a senior architect closes the sale, then quietly hands your core build to the cheapest junior available.",
      body2List: [
        "You end up chasing developers who respond every two weeks.",
        "Paying for rework caused by decisions they made without ever understanding your business.",
        "And managing a project that was supposed to free you from management.",
      ],
      body3: "Léman IT doesn't execute briefs. <strong>We challenge them.</strong>",
      body4Parts: [
        "Before writing a line of code, we absorb your monetization model, your commercial constraints, and your product logic.",
        "We don't need you to translate business decisions into technical language. <strong>That's our job.</strong>",
        "And when the platform goes live, we don't disappear.",
        "<strong>We stay in as your long-term technical partner</strong>, through every version, every pivot, every scale.",
      ],
      testimonial1: {
        quoteTitle: "A rare technical partner who truly understands business logic.",
        body: "Thibault stands out for his excellent execution, combined with a sharp understanding of the operational environment. Beyond his technical quality, he quickly grasps business challenges to propose robust, effective solutions that create long-term value.",
        author: "Maren Knief Clerc",
        role: "Strategic Advisor & COO at KC Advisory",
      },
    },
    sixtyForty: {
      headline: "The difference is in what we propose before you even ask.",
      subtitle: "Léman IT brings strategic insight, flags risks early, and delivers solutions that last. Not just code that ships.",
      visibleLabel: "Visible scope",
      visiblePct: "60",
      visibleDesc: "% typical brief",
      hiddenLabel: "Hidden scope",
      hiddenPct: "40",
      hiddenDesc: "% invisible",
      body1: "A typical technical brief covers roughly 60% of what your software actually needs to survive in the market.",
      body2: "The remaining 40% is invisible until it isn't. Edge cases that break under real user load, operational bottlenecks your team works around with spreadsheets, and scaling infrastructure nobody thought to spec out. Most agencies build the 60%, ship it, and invoice you separately for the rest.",
      body3: "We map the full 100% before architecture begins.",
      body4: "The gaps are identified, scoped, and engineered into the core. Not discovered post-launch, fixing them costs three times as much.",
      caseStudy: {
        title: "A client asked for a press release page.",
        highlight: "We built her a complete CMS instead.",
        body1: "She can now publish, edit, and archive press releases independently. No developer call required. No invoice triggered. No technical friction of any kind.",
        body2: "She didn't ask for it. It was simply the right thing to build for her business.",
        ctaBody: "That's the 40%.",
        cta: "See all client systems we've built",
      },
    },
    scopePillars: {
      headline: "Adapted. Robust. Effective. The three words our clients use.",
      pillars: [
        {
          tag: "Architecture",
          title: "A Stable Platform Built to Scale",
          body: "Rebuilt from the ground up on clean architecture. Technical debt eliminated, vendor lock-in removed. <strong>You own 100% of the code and Server from day one.</strong> No exceptions, no asterisks.",
        },
        {
          tag: "Discovery",
          title: "Mapping Your Hidden Product Needs",
          body: "The 60/40 rule applies directly to your build. We actively <strong>challenge feature logic and close architectural gaps</strong> before they become expensive post-launch emergencies.",
        },
        {
          tag: "Autonomy",
          title: "The Anti-Dependency Control Panel",
          body: "A customized admin dashboard built around your actual workflows. <strong>Run and update your platform daily without a developer on call</strong>, without a technical translator, without friction.",
        },
        {
          tag: "Migration",
          title: "Zero-Downtime Phased Migration",
          body: "Your current revenue stays protected throughout the entire transition. <strong>The new platform deploys in a fully parallel environment and migrates your users seamlessly.</strong> Zero operational disruption.",
        },
        {
          tag: "Infra",
          title: "Production Infrastructure & Deployment",
          body: "Enterprise-grade cloud architecture with real-time performance monitoring and automatic scaling. <strong>One full year of secure hosting is included in the engagement.</strong> No hidden infrastructure costs.",
        },
        {
          tag: "Automation",
          title: "Smart API Integrations & Automation",
          body: "Manual workarounds, disconnected tools, and repetitive data entry are permanently eliminated. We replace them with <strong>automated pipelines engineered to run without supervision.</strong>",
        },
        {
          tag: "Growth",
          title: "Analytics & Growth Infrastructure",
          body: "Conversion tracking, user behavior analytics, and performance benchmarking are embedded into your codebase from day one. <strong>You scale on data, not assumptions.</strong>",
        },
        {
          tag: "AI · Ready",
          title: "AI-Ready Core Framework",
          body: "Your architecture is engineered from the start with secure vector databases and AI-ready infrastructure. <strong>When you implement AI features, operational and API costs stay predictable, not open-ended.</strong>",
        },
      ],
      testimonial2: {
        quoteTitle: "Highly competent fullstack team that proactively drives solutions.",
        body: "Léman IT's technical mastery, combined with their ability to quickly digest business needs, makes a real difference. They are rigorous, deeply professional, and constantly bring proactive technical solutions to the table.",
        author: "Ambre Roguet",
        role: "Head of Operations at Around SA",
      },
    },
    faq: {
      headline: "Frequently asked,",
      highlight: "honestly answered.",
      subtitle: "Six questions every founder asks before trusting us with their core product. No fluff.",
      items: [
        {
          q: "Do we have to pause active marketing or sales while you rebuild?",
          a: "No. Your current platform remains 100% active, revenue-generating, and operational online. Your business continues to onboard users normally while we develop and test the improved platform in parallel on a separate, secure server. We only switch over once the new system is flawless.",
        },
        {
          q: "What happens after the software product goes live?",
          a: "Most agencies hand over a folder of unreadable code and disappear, or trap you in expensive hourly retainers. Léman IT acts as your lifetime technical partner. You get direct phone access to the lead architect, not a project manager, a support ticket, or a junior filter. You retain a direct line for swift, strategic decisions through the entire lifetime of your product.",
        },
        {
          q: "Why is the first step a diagnostic call instead of a fixed price quote?",
          a: "Every version of SaaS carries a different history of technical debt, unoptimized databases, and migration risks. Sending a generic price quote without analyzing your underlying code would be highly irresponsible and inevitably lead to surprise invoices later. The diagnostic call completely protects your budget.",
        },
        {
          q: "What specific technologies and frameworks do you use for the SaaS V2 rebuild?",
          a: "We build on highly maintainable, modern, and industry-standard stacks. We primarily leverage Next.js, React, Node.js, PostgreSQL, and Supabase. We strictly avoid obscure, outdated, or proprietary systems to ensure that any high-level engineer can effortlessly understand and manage your codebase in the future.",
        },
        {
          q: "How do we track development progress and communicate during the build?",
          a: "We operate in highly transparent, short sprints with weekly live demo calls. We use ClickUp for granular task management and provide you with constant, real-time access to a dedicated staging environment so you can physically watch your platform evolve day by day.",
        },
        {
          q: "How do you mathematically measure that the new platform is actually better?",
          a: "We don't rely on gut feelings. We track hard data by embedding conversion tracking, core web vitals, and user behavior tools directly into the code. Post-launch success is measured through concrete speed testing, dramatic drops in server costs, and optimization metrics.",
        },
      ],
      testimonial3: {
        quoteTitle: "Uncompromising professionalism and high-level technical expertise.",
        body: "I highly recommend Léman IT for their seriousness, dedication, and exceptional level of technical expertise across multiple complex projects.",
        author: "Mehdi Maamor",
        role: "Business Developer at Dealzit",
      },
    },
    finalCta: {
      headline: "The first conversation is a diagnostic, not a pitch.",
      subheadline: "We look at your existing product, understand your situation, and tell you honestly what a rebuild requires, before scope or price is discussed.",
      cta: "Align my business and code",
      microcopy: "* Free 30-minute architecture review. No sales pitch, just honest diagnostics.",
      directLine: "Direct line · No filters",
      directTitle: "Speak directly with the lead architect.",
      emailLabel: "Email",
      email: "dev@leman-it.com",
      phoneLabel: "Phone",
      phone: "+33635389512",
      responseLabel: "Response time",
      response: "Under 12 hours, Mon to Fri",
    },
    booking: {
      buttonLabel: "Book",
      ariaLabelOpen: "Book a 30-minute call",
      ariaLabelClose: "Close calendar",
    },
    footer: {
      tagline: "The technical co-founder you never had. Headquartered on the shores of Lake Geneva. Building SaaS platforms that survive scale.",
      yearLabel: "MMXXV · Genève",
      copyright: "© Léman IT SARL · All rights reserved.",
      practice: "Practice",
      stack: "Stack",
      company: "Company",
    },
  },
} as const;

export type V2Translations = typeof v2Translations;
